/**
 * Open the header mega menu on hover (desktop), not just click.
 * Toggles the native <details open> so Dawn's animations, aria state, and
 * header behaviour stay in sync. Click still works; mobile is untouched.
 */
(function () {
  var DESKTOP = '(min-width: 990px)';

  function bind(headerMenu) {
    var details = headerMenu.querySelector('details.mega-menu');
    if (!details) return;
    var summary = details.querySelector('summary');
    var closeTimer;

    function open() {
      if (!window.matchMedia(DESKTOP).matches || details.open) return;
      details.setAttribute('open', '');
      if (summary) summary.setAttribute('aria-expanded', 'true');
    }
    function scheduleClose() {
      if (!window.matchMedia(DESKTOP).matches) return;
      closeTimer = setTimeout(function () {
        details.removeAttribute('open');
        if (summary) summary.setAttribute('aria-expanded', 'false');
      }, 140);
    }

    headerMenu.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
      open();
    });
    headerMenu.addEventListener('mouseleave', scheduleClose);
  }

  function init() {
    document
      .querySelectorAll('.header__inline-menu header-menu')
      .forEach(bind);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
